import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Users from "@/pages/Users";
import Activity from "@/pages/Activity";
import Trash from "@/pages/Trash";
import Setup from "@/pages/Setup";
import ObjectTypesSetup from "@/pages/ObjectTypesSetup";
import Portfolio from "@/pages/Portfolio";
import Analytics from "@/pages/Analytics";
import Plan from "@/pages/Plan";
import { hasRole } from "@/lib/permissions";
import { ProjectProvider } from "@/context/ProjectContext";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children, minRole }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] text-neutral-500 text-sm">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (minRole && !hasRole(user, minRole)) return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <ProjectProvider>
            <Routes>
              <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
              <Route path="/" element={<Protected><Dashboard /></Protected>} />
              <Route path="/setup" element={<Protected minRole="admin"><Setup /></Protected>} />
              <Route path="/setup/object-types" element={<Protected minRole="admin"><ObjectTypesSetup /></Protected>} />
              <Route path="/portfolio" element={<Protected><Portfolio /></Protected>} />
              <Route path="/analytics" element={<Protected><Analytics /></Protected>} />
              <Route path="/plan" element={<Protected><Plan /></Protected>} />
              <Route path="/users" element={<Protected minRole="admin"><Users /></Protected>} />
              <Route path="/activity" element={<Protected><Activity /></Protected>} />
              <Route path="/trash" element={<Protected minRole="admin"><Trash /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-right" />
          </ProjectProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
